/* eslint-disable import/prefer-default-export */
export const THEMES = {
  LIGHT: "LIGHT",
  ONE_DARK: "ONE_DARK",
  UNICORN: "UNICORN",
  BLUE_OCEAN: "BLUE_OCEAN"
};

export const STATES = {
  ASSIGNED: "assigned",
  CREATED: "created",
  NEED_TO_REVIEW: "need_to_review",
  PICKING: "picking",
  PICKED: "picked",
  CHECKED_OUT: "checked_out",
  NEED_TO_TRANSIT_FC: "need_to_transit_fc",
  NEED_TO_CONSOLIDATE: "need_to_consolidate",
  READY_TO_CONSOLIDATE: "ready_to_consolidate",
  IN_TRANSIT_FC: "in_transit_fc",
  CONSOLIDATED: "consolidated",
  AWAITING_APPROVAL: "awaiting_approval",
  AWAITING_REFUND: "awaiting_refund",
  COMPLETED: "completed",
  CANCELLED_BY_OV: "cancelled_by_ov",
  RETURNED: "returned",
  FINISHED: "finished",
  CANCELLED: "cancelled",
  REFUND_REJECTED: "refund_rejected",
  BEING_FULFILLED: "being_fulfilled",
  PAYMENT_FAILED: "payment_failed",
  WAITING_FOR_PAYMENT: "waiting_for_payment",
  HOLD: "hold"
};
export const TICKET_STATES = {
  CREATED: "created",
  PROCESSING: "processing",
  SOLVED: "solved",
  CLOSED: "closed"
};
export const TRANSACTION_STATES = {
  CREATED: "created",
  PENDING: "pending",
  COMPLETED: "completed",
  RETURNED: "returned",
  CANCELLED: "cancelled",
  CANCELLED_BY_OV: "cancelled_by_ov",
  STORED_IN: "stored_in",
  REFUND_TRANSACTION: "refund_transaction",
  PAYMENT_FAILED: "payment_failed",
  HOLD: "hold",
  REQUEST_TO_CREATE_WAYBILL: "request_to_create_waybill",
  WAYBILL_CREATED: "waybill_created"
};

export const BAG_PACKING_MODAL_MESSAGE = {
  READY_TO_CONSOLIDATE: {
    BASKET_NUMBER: 1,
    MESSAGE: "Chờ gộp kiện ngay"
  },
  NEED_TO_CONSOLIDATE: {
    BASKET_NUMBER: 2,
    MESSAGE: "Cần lưu tạm chờ gộp kiện"
  },
  NEED_TO_TRANSIT_FC: {
    BASKET_NUMBER: 3,
    MESSAGE: "Chờ trung chuyển đến nơi gộp kiện"
  }
};
export const MASSUPLOAD_PRODUCT_DOWNLOAD_LINK =
  "https://drive.google.com/u/1/uc?id=1jnQJnbPmG6GTloGZsPGaNej230Ia0fKp&export=download";
export const MASSUPLOAD_SKU_DOWNLOAD_LINK =
  "https://drive.google.com/u/1/uc?id=1vTeJsFe2B7zrhzVq7Izc26kbGS92HX36&export=download";
export const MASSUPLOAD_STOCK_DOWNLOAD_LINK =
  "/static/excel/MassUploadStockTemplate.xlsx";
export const MASSUPLOAD_PRODUCT_MULTI_BARCODE_LINK =
  "https://drive.google.com/uc?export=download&id=1GY0QgVikj2fqfdg01jj6zWLy0HL56JaU";

export const MASSUPLOAD_TYPE = {
  PRODUCT: "items",
  PRICING: "sku_pricing",
  STOCK: "stock",
  CODE: "internal_code",
  MULTI_BARCODE: "barcode"
};

export const UI_CONFIG_ELEMENT_TAG = {
  // view, create, update, delete
  // ANNOUNCEMENT
  VIEW_COD_REPORT: "view_cod_report",
  VIEW_REPORT: "view_report",
  UPDATE_ANNOUNCEMENT: "update_announcement",
  // PRODUCT PAGE
  VIEW_PRODUCT: "view_product",
  CREATE_PRODUCT: "create_product",
  UPDATE_PRODUCT: "update_product",
  // CATEGORY PAGE
  VIEW_CATEGORY: "view_category",
  CREATE_CATEGORY: "create_category",
  UPDATE_CATEGORY: "update_category",
  DELETE_CATEGORY: "delete_category",
  // MEDIA PAGE
  VIEW_MEDIA: "view_media",
  CREATE_MEDIA: "create_media",
  UPDATE_MEDIA: "update_media",
  DELETE_MEDIA: "delete_media",
  // SUPPLIER PAGE
  VIEW_SUPPLIER: "view_supplier",
  CREATE_SUPPLIER: "create_supplier",
  UPDATE_SUPPLIER: "update_supplier",
  // STOCK PAGE
  VIEW_STOCK: "view_stock",
  CREATE_STOCK: "create_stock",
  UPDATE_STOCK: "update_stock",
  // STATION PAGE
  VIEW_STATION: "view_station",
  CREATE_STATION: "create_station",
  UPDATE_STATION: "update_station",
  DELETE_STATION: "delete_station",
  VIEW_COUNTER: "view_counter",
  CREATE_COUNTER: "create_counter",
  DELETE_COUNTER: "delete_counter",
  UPDATE_COUNTER: "update_counter",
  UPDATE_STATION_STOCK: "update_station-stock",
  // PROMOTION PAGE
  VIEW_PROMOTION: "view_promotion",
  CREATE_PROMOTION: "create_promotion",
  UPDATE_PROMOTION: "update_promotion",
  // SHIPPING TYPE PAGE
  VIEW_SHIPPING_TYPE: "view_shipping-type",
  CREATE_SHIPPING_TYPE: "create_shipping-type",
  UPDATE_SHIPPING_TYPE: "update_shipping-type",
  // CUSTOMER FEE PAGE
  VIEW_CUSTOMER_FEE: "view_customer_fee",
  CREATE_CUSTOMER_FEE: "create_customer_fee",
  UPDATE_CUSTOMER_FEE: "update_customer_fee",
  DELETE_CUSTOMER_FEE: "delete_customer_fee",
  // CAPACITY PAGE
  VIEW_CAPACITY: "view_capacity",
  CREATE_CAPACITY: "create_capacity",
  UPDATE_CAPACITY: "update_capacity",
  DELETE_CAPACITY: "delete_capacity",
  // CUSTOMER PAGE
  VIEW_CUSTOMER: "view_customer",
  UPDATE_CUSTOMER: "update_customer",
  // NOTIFICATION PAGE
  VIEW_NOTIFICATION: "view_notification-rule",
  CREATE_NOTIFICATION: "create_notification-rule",
  UPDATE_NOTIFICATION: "update_notification-rule",
  DELETE_NOTIFICATION: "delete_notification-rule",
  VIEW_NOTIFICATION_SEND_ALL: "view_notification-send-all",
  CREATE_NOTIFICATION_SEND_ALL: "create_notification-send-all",
  UPDATE_NOTIFICATION_SEND_ALL: "update_notification-send-all",
  DELETE_NOTIFICATION_SEND_ALL: "delete_notification-send-all",
  VIEW_NOTIFICATION_HISTORY: "view_notification-history",
  // ORDER VERIFICATION PAGE
  VIEW_OV: "view_ov",
  UPDATE_PICKLIST: "update_picklist",
  VIEW_OV_RULE: "view_ov_rule",
  CREATE_OV_RULE: "create_ov_rule",
  UPDATE_OV_RULE: "update_ov_rule",
  DELETE_OV_RULE: "delete_ov_rule",
  // COMMENT PAGE
  VIEW_COMMENT: "view_comment",
  CREATE_COMMENT: "create_comment",
  UPDATE_COMMENT: "update_comment",
  // REVIEW PAGE
  VIEW_REVIEW: "view_review",
  UPDATE_REVIEW: "update_review",
  // TICKET PAGE
  VIEW_TICKET: "view_ticket",
  UPDATE_TICKET: "update_ticket",
  // REFUND TRANSACTION PAGE
  VIEW_TRANSACTION: "view_transaction",
  UPDATE_TRANSACTION: "update_transaction",
  // RETURN PACKAGE PAGE
  VIEW_RETURN_PACKAGE: "view_return-package",
  // ORDER PAGE
  VIEW_ORDER: "view_order",
  UPDATE_ORDER: "update_order",
  // BAG PACKING PAGE
  VIEW_BAG: "view_bag",
  UPDATE_BAG: "update_bag",
  // using UPDATE_PICKLIST
  // USER PAGE WAIT FOR MINH TO COMPLETE THEN ADD AUTHORIZE AFTER THAT
  VIEW_USER: "view_user",
  CREATE_USER: "create_user",
  UPDATE_USER: "update_user",
  DELETE_USER: "delete_user",
  // ROLE PAGE
  VIEW_ROLE: "view_role",
  CREATE_ROLE: "create_role",
  UPDATE_ROLE: "update_role",
  // PERMISSION PAGE
  VIEW_PERMISSION: "view_permission",
  CREATE_PERMISSION: "create_permission",
  UPDATE_PERMISSION: "update_permission",
  // LOCATION PAGE
  VIEW_LOCATION: "view_location",
  // REASON PAGE
  VIEW_REASON: "view_reason",
  CREATE_REASON: "create_reason",
  UPDATE_REASON: "update_reason",
  DELETE_REASON: "delete_reason",
  // LANGUAGE PAGE
  VIEW_LANGUAGE: "view_language",
  CREATE_LANGUAGE: "create_language",
  UPDATE_LANGUAGE: "update_language",
  DELETE_LANGUAGE: "delete_language",
  // LANGUAGE SETTING PAGE
  VIEW_LANGUAGE_SETTING: "view_language_setting",
  CREATE_LANGUAGE_SETTING: "create_language_setting",
  UPDATE_LANGUAGE_SETTING: "update_language_setting",
  DELETE_LANGUAGE_SETTING: "delete_language_setting",
  // MASSUPLOAD PAGE
  CREATE_MASSUPLOAD_PRODUCT: "create_massupload_product",
  CREATE_MASSUPLOAD_PRICING: "create_massupload_pricing",
  CREATE_MASSUPLOAD_STOCK: "create_massupload_stock",
  CREATE_MASSUPLOAD_CODE: "create_massupload_code",
  CREATE_MASSUPLOAD_MULTI_BARCODE: "create_massupload_multi_barcode",
  // POLICY PAGE
  VIEW_POLICY: "view_policy",
  CREATE_POLICY: "create_policy",
  UPDATE_POLICY: "update_policy",
  DELETE_POLICY: "delete_policy",
  // TAG PAGE
  VIEW_TAG: "view_tag",
  CREATE_TAG: "create_tag",
  UPDATE_TAG: "update_tag",
  DELETE_TAG: "delete_tag",
  // BRAND PAGE
  VIEW_BRAND: "view_brand",
  CREATE_BRAND: "create_brand",
  UPDATE_BRAND: "update_brand",
  DELETE_BRAND: "delete_brand",
  // PRIVATE COUPON PAGE
  VIEW_PRIVATE_COUPON: "view_coupon",
  CREATE_PRIVATE_COUPON: "create_coupon",
  UPDATE_PRIVATE_COUPON: "update_coupon",
  DELETE_PRIVATE_COUPON: "delete_coupon",
  // COUPON PAGE
  VIEW_COUPON_LIMIT: "view_coupon-limit",
  CREATE_COUPON_LIMIT: "create_coupon-limit",
  VIEW_COUPON_BUDGET: "view_coupon-budget",
  UPDATE_COUPON_BUDGET: "update_coupon-budget",
  // PICKLIST PAGE
  VIEW_PICKLIST: "view_picklist",
  // PLATFORM PAGE
  VIEW_PLATFORM: "view_platform",
  // SELLER PAGE
  VIEW_SELLER: "view_seller",
  CREATE_SELLER: "create_seller",
  UPDATE_SELLER: "update_seller",
  DELETE_SELLER: "delete_seller",

  OWNER: "super_duper_omega",
  OWNER_USER: "super_duper_omega_user",
  REJECT_SENTENCE: "You don't have permission to view ",
  REJECT_SENTENCE_EDIT: "You don't have permission to edit "
};

export const WAIT_TIME_FOR_SEARCH = 1000;

export const PAYMENT_METHOD = {
  COD: "cod",
  VNPAY: "vnpay",
  MOMO: "momo"
};

export const ZERO_UUID = "00000000-0000-0000-0000-000000000000";
export const isZeroUUID = (uuid) => ZERO_UUID === uuid;

export const LOCAL_STORAGE_VARIABLE_NAME = {
  BAGGING_HISTORY: "baggingHistory",
  PACKAGING_HISTORY: "packagingHistory",
  USER_ID: "userId"
};

export const COMMENT_CREATOR_TYPE = {
  CUSTOMER: 0,
  USER: 1
};

export const MASSUPLOAD_OBJECT = {
  PRODUCT: "items",
  PRICING: "sku_pricing",
  STOCK: "stock",
  CODE: "internal_code",
  MULTI_BARCODE: "barcode",
  "PRODUCT.ADD_NEW_PRODUCT": "create_items",
  "PRODUCT.UPDATE_PRODUCT_INFO": "update_items",
  "PRODUCT.ADD_MORE_CATEGORY": "update_items_category",
  "PRODUCT.RESET_CATEGORY": "replace_data"
};

export const STORAGE_AND_TRANSPORT_ATTRIBUTE_KEY = {
  AMBIENT_CHEMISTRY: "ambient-chemistry",
  AMBIENT_FOOD: "ambient-food",
  AMBIENT_NORMAL: "ambient-normal",
  CHILLED_00: "chilled00",
  CHILED_05: "chilled05",
  CHILLED_10: "chilled10",
  FROZEN_00: "frozen00",
  FROZEN_01: "frozen01",
  FRAGILE: "fragile",
  HEAVY_BULKY: "heavy_bulky"
};
export const HOLD_STATES = {
  APPROVE: "approval",
  REJECT: "reject"
};
export const PROMOTION_TYPE = {
  NORMAL: "promotion",
  PRP: "promotion_first_order",
  PWP: "promotion_pwp"
};
export const WAYBILL_STATUS = {
  WAITING: "waiting",
  CREATED: "created",
  CANCELED: "canceled"
};

export const FRAGILE_HEAVY = ["fragile", "heavy_bulky"];

export const TOKEN_DUMMY =
  "c1bbee9d92d6737b072f113396bbb69fa677467a9cd0da370224f6f62fd5baed";

export const TODAY = new Date().toISOString();

export const KEY_CODE = {
  MINUS: 189,
  PLUS: 187,
  KEY_E: 69,
  KEY_COMMA: 188,
  PERIOD: 190,
  NUMPAD: 110
};

// REGEX
export const TAX_NUMBER_REGEX = /^(((\d){10}-(\d){3})|((\d){10}))$/;
export const ACCOUNT_NUMBER_REGEX = /^[0-9]*$/;
export const regex_email = /^[\w-\\.]+@([\w-]+\.)+[\w-]{2,9}$/;

export const DELIVERY_METHOD_ID = {
  HOME_DELIVERY: "home_delivery",
  STATION_DELIVERY: "station_delivery"
};

export const DELIVERY_METHOD = [
  {
    id: DELIVERY_METHOD_ID.HOME_DELIVERY,
    name: "Giao hàng tận nơi",
    name_en: "Home delivery"
  },
  {
    id: DELIVERY_METHOD_ID.STATION_DELIVERY,
    name: "Lấy hàng tại Pickup Point",
    name_en: "Station delivery"
  }
];

export const DEFAULT_PRODUCT_NAME = {vi: "Sản phẩm", en: "Product"};

export const ERROR_IMAGE = "/static/images/error-image-generic.png";

export const MS_PER_MINUTE = 60000;

export const FORMAT_DATE_TIME_TYPE_I = "MMMM DD, YYYY HH:mm:ss";

export const FCM_TOKEN_LOCAL_STORAGE = "fcmToken";

export const META_KEY = {
  GENERAL_OVERWEIGHT: "general_overweight"
};

export const PICK_LIST_STATE = {
  CHECKED_OUT: "checked_out",
  ASSIGNED: "assigned",
  HOLD: "hold",
  FAILED_COLLECTION: "failed_collection",
  SYSTEM_CANCELLED_ORDER: "system_cancelled_order",
  WAITING_FOR_PAYMENT: "waiting_for_payment",
  STORED_IN: "stored_in",
  PICKING: "picking",
  PAYMENT_FAILED: "payment_failed",
  CANCELLED: "cancelled",
  PICKED: "picked",
  BEING_FULFILLED: "being_fulfilled",
  WAITING_LAST_OV: "waiting_last_ov",
  CREATED: "created",
  WAITING_FOR_HANDED: "waiting_for_handed",
  CANCELLED_BY_OV: "cancelled_by_ov",
  COMPLETED: "completed"
};

export const BIKE_EN = "Bike";
export const TRUCK_EN = "Truck";
export const BIKE_VI = "Xe máy";
export const TRUCK_VI = "Xe tải";
export const NUMBER_MONEY_UNIT_TRUCK = 10000;
export const NUMBER_MONEY_UNIT_BIKE = 5000;
export const MAX_FILE = 5;

export const LIST_TRANSPORTER = [
  {id: 1, name: BIKE_VI, name_en: BIKE_EN},
  {id: 2, name: TRUCK_VI, name_en: TRUCK_EN}
];

export const AHAMOVE_PACKING_TICKET = "ahamovePackingTicket";
export const AHAMOVE_PACKING_TICKET_VAN = "ahamovePackingTicketVan";
export const SETUP_CAMPAIGN_BY = {PRODUCT: "product", CATEGORY: "category"};
export const AHAMOVE_TRANPORTER = "Ahamove";
export const INHOUSE_TRANPORTER = "InHouse";
export const ERROR_404_GRAB = "Code: 106. Reason: Package over weight limit";
export const GRAB_EXPRESS_TRANSPORTER = "GrabExpress";
export const LALAMOVE_TRANSPORTER = "Lalamove";
export const CONFIG_3PLS = "3pls_config";
export const OVERWEIGHT_CONFIG = "3pl_overweight";
export const DATA_TRUCK_SEVICES = "3pls_truck_service";
export const INVALID_DISTANCE = "INVALID_DISTANCE";
export const TMS_CONFIG = "tms_configuration";
export const BOOKING_TYPE = "booking_type";
export const CREATE_AT_DESC = "created_at desc";
export const UPDATE_WAYBILL_SUCCESS = "UPDATE_WAYBILL_SUCCESS";
export const STATION_ID = "stationId";
export const SUCCESS = "success";
export const ERROR_MS_SHIPPING = "ERR-MS-SHIPPING-003";
export const CENTRALWEB = "centralweb";
export const ACCESS_TOKEN = "accessToken";
export const NOT_PERMISSION = "NOT PERMISSION";

// PRODUCT BUNDLE
export const PHYSICAL_BUNDLE = "physical_bundle";
export const VIRTUAL_BUNDLE_FIXED_PRICE = "virtual_bundle";
export const VIRTUAL_BUNDLE_TOTAL_PRICE = "group_bundle";

export const PRD_BUNDLE_NAME = {
  [PHYSICAL_BUNDLE]: {
    vi: "Gói cố định",
    en: "Physical Bundle"
  },
  [VIRTUAL_BUNDLE_FIXED_PRICE]: {
    vi: "Gói ảo",
    en: "Virtual Bundle"
  },
  [VIRTUAL_BUNDLE_TOTAL_PRICE]: {
    vi: "Gói theo nhóm",
    en: "Group Bundle"
  }
};
